"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/~/rxjs/util/isFunction.js
// module id = ../../../../rxjs/util/isFunction.js
// module chunks = 3